export const MOBILE_CODE_EDITOR_TABS_HEIGHT = '72px';
